
import React ,  { useState , useEffect } from 'react';

import { useUser} from '../../state/reactquery';
import { formatdatehistory } from '../../utils/utils_dates';
import { axios_eventstracks_getall , axios_eventstracks_updateread } from '../../axios/axios_eventstracks';

import './EcranEventsdivacks.scss';

const transformedDataAdmin = (dataevent) => {
    let mystring ='';
    try{ const parsed = JSON.parse(dataevent?.replace(/\\"/g, '"')||'{}') ;
         Object.keys(parsed).forEach(key  => { 
        typeof parsed[key] === 'string' && (mystring += parsed[key] + ' -- ') ;
        typeof parsed[key] === 'object' && (mystring += JSON.stringify(parsed[key]) + ' -- ') ;});
    }catch(err){console.error('Error parsing dataevent:', err);  }
    return mystring

}


const transformedDataGestion = (dataevent) => {
    let mystring = '';
    try{ const parsed = JSON.parse(dataevent?.replace(/\\"/g, '"')||'{}') ;
        parsed.nom_souscripteur && (mystring += parsed.nom_souscripteur + '  ');
        parsed.prenom_souscripteur && (mystring += parsed.prenom_souscripteur + '   ');
        parsed.type_gestion && (mystring += parsed.type_gestion + '   '); 
    }catch(err){mystring = dataevent;}
    return mystring || '';
}

const classNames = require('classnames');

function EcranEventsdivacks() {
     const {data: user} = useUser(localStorage.getItem('token'))  ;
     const [datas, setDatas] = useState([]) ;

     const role_divacks = user?.role === 'SUPERADMIN' ?'superadmin':'gestion' ;

      const transformedData = role_divacks === 'superadmin' ? transformedDataAdmin : transformedDataGestion ;

     async function fetchDatas(){
        const requete =await axios_eventstracks_getall(role_divacks) ; 
        setDatas(requete.data) ;
     }


     const clickevent = async (e)=>{    
        const id = e.currentTarget.getAttribute('id');
        if (!id) return;
        const eventtrack = datas.find(d => d.id === id);
         if (!eventtrack || eventtrack.vu===1) return;
        const others = datas.filter(d => d.id !== id);
        setDatas([...others, {...eventtrack, vu: 1}]);
        await axios_eventstracks_updateread(id);
    }

     useEffect(() => {fetchDatas()}, []);

  return ( <div className='ecraneventsdivacks' >
            <h1>Historique des événements</h1>
                {datas?.sort((a,b)=>new Date(b.date) - new Date(a.date))?.map(d=><div onClick={clickevent} className={classNames("eventtrack",{"vu":d.vu===1})} key={d.id} id={d.id}>
                                <div className ='eventtrack_line1div'>{formatdatehistory(d.date)}</div>
                                <div  className ='eventtrack_line1div'>{d.type_event}</div>
                                <div  className ='eventtrack_line1div'>{d.commercial}</div>
                                <div  className ='eventtrack_line1div'>{d.courtier}</div>
                                <div  className ='eventtrack_line1div'>{d.compagnie}</div>                 
                                <div className ='eventtrack_line2' >{transformedData(d.data)}</div>    
                            </div>)} 
            </div>) ;

}


export default EcranEventsdivacks;